var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:{ 'px-1': _vm.$vuetify.breakpoint.xsOnly },attrs:{"fluid":!_vm.centered,"fill-height":_vm.centered && !_vm.$vuetify.breakpoint.xsOnly,"justify-center":_vm.centered,"tag":"section"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }